<template>
    <div class="row ">
        <div class="col-12 text-center">
            {{ this.getDateFormatted() }}
        </div>
        <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-between">
                <li class="page-item" >
                    <a class="page-link"  @click="loadPrev()">&laquo;</a>
                </li>
                <li class="page-item" >
                    <a class="page-link" href="#" @click="loadNext()">&raquo;</a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="row">
        <div class="col-12 my-2" v-for="(data, orga) in sortedPlantsByOrganisation" :key="orga">
            <div class="card shadow-sm" >
                <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="h5 mb-0">{{ orga }}</p>
      
                    <!-- Dropdown Menü -->
                    <div class="dropdown">
                        <button 
                            class="btn" 
                            type="button" 
                            id="dropdownMenuButton" 
                            data-bs-toggle="dropdown" 
                            aria-expanded="false"
                        >
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                            <li>
                                <a class="dropdown-item" href="#" @click="downloadReport(data.organisation_id, orga)">
                                    <i class="fa-solid fa-file-pdf"></i> {{ $t("export_itemization_pdf") }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="card-body ">
                    <div 
                        v-if="data.invoice_recipient.name" 
                        class="border rounded p-2 mt-1 bg-light small text-muted my-2"
                    >
                        <div class="row">
                            <!-- Linke Spalte: Name + Adresse -->
                            <div class="col">
                            <div><strong>{{ data.invoice_recipient.name }}</strong></div>
                            <div v-if="data.invoice_recipient.zusatz">📧 {{ data.invoice_recipient.zusatz }}</div>
                            <div>{{ data.invoice_recipient.strasse }}</div>
                            <div>{{ data.invoice_recipient.plz }} {{ data.invoice_recipient.ort }}</div>
                            <div>{{ data.invoice_recipient.land }}</div>
                            </div>
                            
                            <!-- Rechte Spalte: Kontakt + Steuer -->
                            <div class="col">
                            <div v-if="data.invoice_recipient.email">📧 {{ data.invoice_recipient.email }}</div>
                            <div v-if="data.invoice_recipient.telefon">📞 {{ data.invoice_recipient.telefon }}</div>
                            <div v-if="data.invoice_recipient.ust_id">USt-ID: {{ data.invoice_recipient.ust_id }}</div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <th class="w-50" rowspan="2">{{ $t("park_plant") }}</th>
                                <th class="w-25" rowspan="2">{{ $t("cost") }}</th>
                                <th rowspan="2">{{ $t("is_invoiced") }}</th>
                                <th rowspan="2">{{ $t("is_payed") }}</th>
                                <th class="w-12" colspan="2">{{ $t("num_sms") }}</th>
                                <th class="w-12" colspan="2">{{ $t("num_email") }}</th>
                            </tr>
                            <tr>
                                <th>{{ $t("quantity") }}</th>
                                <th>{{ $t("cost") }}</th>
                                <th>{{ $t("quantity") }}</th>
                                <th>{{ $t("cost") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="plant in data.plants"
                                v-bind:key="plant.name">
                                <td> {{ plant.name }} 
                                    <i class="fa-solid fa-eye" v-if="plant.is_view_plant" ></i>
                                    <i class="fa-solid fa-bench-tree" v-if="plant.is_park"></i>
                                    <div 
                                        v-if="plant.invoice_recipient" 
                                        class="border rounded p-2 mt-1 bg-light small text-muted"
                                    >
                                        <div class="row">
                                            <!-- Linke Spalte: Name + Adresse -->
                                            <div class="col">
                                            <div><strong>{{ plant.invoice_recipient.name }}</strong></div>
                                            <div v-if="plant.invoice_recipient.zusatz">📧 {{ plant.invoice_recipient.zusatz }}</div>
                                            <div>{{ plant.invoice_recipient.strasse }}</div>
                                            <div>{{ plant.invoice_recipient.plz }} {{ plant.invoice_recipient.ort }}</div>
                                            <div>{{ plant.invoice_recipient.land }}</div>
                                            </div>
                                            
                                            <!-- Rechte Spalte: Kontakt + Steuer -->
                                            <div class="col">
                                            <div v-if="plant.invoice_recipient.email">📧 {{ plant.invoice_recipient.email }}</div>
                                            <div v-if="plant.invoice_recipient.telefon">📞 {{ plant.invoice_recipient.telefon }}</div>
                                            <div v-if="plant.invoice_recipient.ust_id">USt-ID: {{ plant.invoice_recipient.ust_id }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <input type="number" class="form-control" :disabled="!(this.currentDate.getMonth() == this.liveDate.getMonth())"
                                        v-model="plant.monthly_cost" 
                                        @input="debouncedUpdate(plant, data.organisation_id, 'monthly_cost')">
                                </td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input type="checkbox" class="form-check-input" role="switch"
                                            v-model="plant.is_invoiced" 
                                            @change="updateBillingInformation(plant, data.organisation_id, 'is_invoiced')">
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input type="checkbox" class="form-check-input" role="switch"
                                            v-model="plant.is_payed" 
                                            @change="updateBillingInformation(plant, data.organisation_id, 'is_payed')">

                                    </div>
                                </td>
                                <td> {{ plant.total_sms }}</td>
                                <td> {{ plant.price_sms }} €</td>
                                <td> {{ plant.total_email }}</td>
                                <td> {{ plant.price_email }} €</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>Summe</th>
                                <th>{{ data.sum_monthly_cost }} €</th>
                                <th></th>
                                <th></th>
                                <th>{{ data.sum_sms }}</th>
                                <th>{{ data.sum_sms_price }} €</th>
                                <th>{{ data.sum_email }}</th>
                                <th>{{ data.sum_email_price }} €</th>
                            </tr>
                        </tfoot>
                    </table>
                
                </div>
            </div>
        </div>
    </div>
    <!-- Sticky Card -->
    <div 
        class="card shadow-lg border-0"
        style="position: fixed; bottom: 1rem; left: 50%; transform: translateX(-50%); width: 400px; z-index: 1050;"
    >
        <div class="card-body d-flex justify-content-between text-center">
            <div>
                <strong>Gesamt:</strong><br>
                {{ globalSums.total }} €
            </div>
            <div>
                <strong>Bezahlt:</strong><br>
                {{ globalSums.paid }} €
            </div>
            <div>
                <strong>Offen:</strong><br>
                {{ globalSums.open }} €
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios'
const fileDownload = require('js-file-download')

export default {
    name: 'PlantNotifications',
    components: {
    },
    data() {
        return {
            notification_parks: [],
            currentDate: {},
            liveDate: {},
            debounceTimers: {}
        }
    },
    mounted(){
        this.getDataForThisMonth()
    },
    updated(){

    },
    unmounted(){
        console.log('component unmounted')
        
    },
    methods: {

        updateBillingInformation(plant, organisation_id, field) {
            axios.patch(`/api/v1/billing/update_billing_information/organisations/${organisation_id}/item/${plant.id}/`, {
                [field]: plant[field],
                ['month']: this.currentDate.getMonth() +1,
                ['year']: this.currentDate.getFullYear(),
                ['is_park']: plant.is_park
            })
            .then(response => {
                    this.getDataForThisMonth()
                })
            .catch(err => {
                console.error("Update failed:", err);
            });
        },

        // mit Debounce (für monthly_cost)
        debouncedUpdate(plant, organisation_id, field) {
            const key = `${plant.id}-${field}`;

            if (this.debounceTimers[key]) {
                clearTimeout(this.debounceTimers[key]);
            }

            this.debounceTimers[key] = setTimeout(() => {
                this.updateBillingInformation(plant, organisation_id, field);
            }, 500); // 0,5 Sekunden warten
        },
        getDataForThisMonth(){
            console.log('entry getDataForThisMonth')
            if (!this.currentDate || !(this.currentDate instanceof Date)) {
                this.currentDate = new Date();
                this.liveDate = new Date();
            }
            var lastDayOfMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() +1, 0)
            let startIntervall = {}
            let endIntervall = {}
            startIntervall['day'] = '1'
            startIntervall['month'] = lastDayOfMonth.getMonth()
            startIntervall['year'] = lastDayOfMonth.getFullYear()
            endIntervall['day'] = lastDayOfMonth.getDate()
            endIntervall['month'] = lastDayOfMonth.getMonth()
            endIntervall['year'] = lastDayOfMonth.getFullYear()
            var formData = {}
            formData.startIntervall = startIntervall
            formData.endIntervall = endIntervall
            formData.type_data = 'plain'
            axios
                .post('/api/v1/organisation/get_plant_notification_park/', formData)
                .then(response => {
                    this.notification_parks = response.data
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    this.notification_parks = []
                })
            console.log('exit getDataForThisMonth')
        },
        loadNext() {
            this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() +1, 1)
            this.getDataForThisMonth()
        },
        loadPrev() {
            this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() -1, 1)
            this.getDataForThisMonth()
        },

        getDateFormatted(){
            if (!this.currentDate || !(this.currentDate instanceof Date)) {

                return ""
            }
            return this.currentDate.toLocaleDateString('de-DE', {month: '2-digit', year: 'numeric'})
        },
        downloadReport(organisation_id, organisation_name){
            console.log('entry downloadReport', organisation_id)
            axios
                .get(`/api/v1/organisation/${organisation_id}/notification_report/${this.currentDate.getFullYear()}/${this.currentDate.getMonth() +1}`, {responseType: 'blob'})
                .then(response => {
                    console.log('fertig')
                    fileDownload(response.data, `${this.currentDate.getFullYear()}_${this.currentDate.getMonth() +1}_Einzelnachweise_${organisation_name}.pdf`);
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    
                })
        }
    },
    computed:{
        globalSums() {
            let total = 0
            let paid = 0

            Object.values(this.sortedPlantsByOrganisation).forEach(org => {
                org.plants.forEach(plant => {
                    const cost = parseFloat(plant.monthly_cost) || 0
                    total += cost
                    if (plant.is_payed) {
                    paid += cost
                    }
                })
            })

            return {
                total: total.toFixed(2),
                paid: paid.toFixed(2),
                open: (total - paid).toFixed(2)
            }
        },
        currentProperties(){
                return {allOrganisations: this.allOrganisations}
            },
        currentNotificationProperties(){
                return {organisation: this.currentOrganisation}
            },
        sortedPlantsByOrganisation() {
            // data ist ein Objekt mit Organisationsnamen als Keys
            const result = {}

            Object.entries(this.notification_parks).forEach(([orgName, orgData]) => {
            const plants = orgData.plants || []

            // Split plants in zwei Gruppen
            const noRecipient = plants.filter(p => {
                // Prüfe ob invoice_recipient leer ist
                return !p.invoice_recipient || !p.invoice_recipient.name || p.invoice_recipient.name.trim() === ''
            })
            const withRecipient = plants.filter(p => {
                return p.invoice_recipient && p.invoice_recipient.name && p.invoice_recipient.name.trim() !== ''
            })

            // Sortiere noRecipient alphabetisch nach Anlagenname
            noRecipient.sort((a,b) => a.name.localeCompare(b.name))

            // Sortiere withRecipient zuerst nach Rechnungsempfängername, dann nach Anlagenname
            withRecipient.sort((a,b) => {
                const cmpRecipient = a.invoice_recipient.name.localeCompare(b.invoice_recipient.name)
                if(cmpRecipient !== 0) return cmpRecipient
                return a.name.localeCompare(b.name)
            })

            // Kombiniere Ergebnis: erst ohne Rechnungsempfänger, dann mit
            result[orgName] = {
                ...orgData,
                plants: [...noRecipient, ...withRecipient]
            }
            })

            return result
        }
    }
}
</script>
